// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./components/rate/style/index.less
// module id = 1060
// module chunks = 1